import React, { useState, useEffect } from 'react';
import { ListGroup, Card, Form } from 'react-bootstrap';
const SubsidiaryCompanySelector = _ref => {
  let {
    dashboardData,
    selectedSubsidiaryCompanyIds,
    isMultipleSelectionEnabled,
    setIsMultipleSelectionEnabled,
    selectSubsidiaryCompany,
    isAllSelected,
    setIsAllSelected
  } = _ref;
  const [filteredSubsidiaryCompanies, setFilteredSubsidiaryCompanies] = useState([]);
  const [subsidiaryCompanies, setSubsidiaryCompanies] = useState([]);
  useEffect(() => {
    const subsidiaryCompanies = dashboardData && selectedSubsidiaryCompanyIds ? dashboardData.subsidiary_companies : [];
    setFilteredSubsidiaryCompanies(subsidiaryCompanies);
    setSubsidiaryCompanies(subsidiaryCompanies);
  }, [dashboardData, selectedSubsidiaryCompanyIds]);
  const handleSubsidiaryCompanySearch = e => {
    const searchValue = e.target.value;
    if (searchValue) {
      const filteredSubsidiaryCompanies = subsidiaryCompanies.filter(bu => {
        var _bu$name;
        return (_bu$name = bu.name) === null || _bu$name === void 0 ? void 0 : _bu$name.toLowerCase().includes(searchValue === null || searchValue === void 0 ? void 0 : searchValue.toLowerCase());
      });
      setFilteredSubsidiaryCompanies(filteredSubsidiaryCompanies);
    } else {
      setFilteredSubsidiaryCompanies(subsidiaryCompanies);
    }
  };
  return /*#__PURE__*/React.createElement(Card, {
    className: "p-2 dashboard-business-unit-selector-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    className: "dashboard-business-unit-search mb-2 me-2",
    placeholder: "Search",
    onChange: handleSubsidiaryCompanySearch
  }), /*#__PURE__*/React.createElement("span", {
    className: "material-icons mt-1 dashboard-business-unit-multiple-select \n\t\t\t\t\t\t".concat(isMultipleSelectionEnabled ? 'dashboard-business-unit-multiple-select__active' : 'dashboard-business-unit-multiple-select__inactive'),
    onClick: () => setIsMultipleSelectionEnabled(!isMultipleSelectionEnabled)
  }, "checklist_rtl")), /*#__PURE__*/React.createElement(ListGroup, {
    defaultActiveKey: "all"
  }, /*#__PURE__*/React.createElement(ListGroup.Item, {
    className: "busines-unit-item mb-1",
    active: isAllSelected,
    key: "all",
    action: true,
    onClick: () => setIsAllSelected(!isAllSelected)
  }, "All"), filteredSubsidiaryCompanies.map(company => /*#__PURE__*/React.createElement(ListGroup.Item, {
    className: "busines-unit-item mb-1",
    active: selectedSubsidiaryCompanyIds.findIndex(id => id === company.id) > -1,
    key: company.id,
    action: true,
    onClick: () => selectSubsidiaryCompany(company.id)
  }, company.name)), /*#__PURE__*/React.createElement(ListGroup.Item, {
    className: "busines-unit-item mb-1",
    active: selectedSubsidiaryCompanyIds.includes(0),
    key: "no-subsidiary",
    action: true,
    onClick: () => selectSubsidiaryCompany(0)
  }, "No Subsidiary Company")));
};
export default SubsidiaryCompanySelector;